module.exports = __webpack_public_path__ + "static/login-footer-1deacdee3663d93e8c8e1f7ca57713eb.png";